<ng-container *ngIf="!isMobileView">
    <div class="row mt-3">
        <div class="col-xl col-md">
            <h4 style="float: left;">{{offerDetails}}</h4>
        </div>
    </div>
    <div class="row detalii-comparator-gaz">
        <div class="col-sm shadow m-3 p-3 mb-5 bg-white label-bold rounded">
            <div class="row">
                <p><b>{{offerTypeName}}:</b> <a href="{{gasComparatorResult.url_oferta}}"
                        target="_blank">{{gasComparatorResult.nume_oferta}}</a></p>

            </div>
            <div class="row">
                <p><b>{{offerType}}:
                    </b> {{gasComparatorResult.tip_oferta}}</p>
            </div>
            <div class="row">
                <p><b>{{offerValability}}:
                    </b>{{gasComparatorResult.perioada_oferta_min}}-{{gasComparatorResult.perioada_oferta_max}}</p>
            </div>
            <div class="row">
                <p><b>{{clientType}}:
                    </b>{{gasComparatorResult.tip_client}}</p>
            </div>
            <div class="form-group row">
                <p class="mr-3"><b>{{connectionMethod}}:</b>
                    {{gasComparatorResult.mod_racordare}}</p>
            </div>
            <div class="form-group row">
                <p class="mr-3"><b>{{consumptionCategory}}:</b>
                    {{gasComparatorResult.categorie_client}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{regulatedServicesIncluded}}:</b>
                    {{gasComparatorResult.servicii_de_reglementare_incluse}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{lastUpdate}}:</b>
                    {{gasComparatorResult.ultima_actualizare}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{contractModel}}:</b>
                    <ng-container *ngFor="let modelContract of gasComparatorResult.model_contract">
                        <div *ngIf="(!isEditable && modelContract.fisier) || (isEditable && modelContract)"
                            class="form-group row">
                            <div *ngIf="!isEditable && modelContract.fisier" class="col-xl col-md">
                                <a href="{{comparatorDocumentsUrl + modelContract.fisier}}"
                                    target="_blank">{{modelContract.nume}}</a>
                            </div>
                            <div *ngIf="isEditable && modelContract" class="col-xl col-md">
                                <a *ngIf="isEditable" href="{{comparatorDocumentsUrl + modelContract}}"
                                    target="_blank">{{modelContract}}</a>
                            </div>
                        </div>
                    </ng-container>
                </p>
            </div>
        </div>
        <div class="col-sm shadow m-3 p-3 mb-5 label-bold bg-white rounded">
            <div class="form-group row">
                <p><b>{{contractDuration}}:</b>
                    {{gasComparatorResult.durata_contract}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{guarantees}}: </b>
                    {{gasComparatorResult.garantii}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{invoiceFrequency}}: </b>
                    {{gasComparatorResult.frecventa_emitere_factura}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{paymentTerm}}: </b>
                    {{gasComparatorResult.termen_plata}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{invoiceTransmissionNethod}}: </b>
                    {{gasComparatorResult.mod_transmitere_factura}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{documentsMode}}: </b>
                    <span *ngIf="gasComparatorResult?.mod_transmitere_incheiere_contract"
                        [innerHTML]="gasComparatorResult?.mod_transmitere_incheiere_contract | sanitizeHtml"></span>
                <p>
            </div>
            <div class="form-group row">
                <p><b>{{discountsOffered}}: </b>
                    {{gasComparatorResult.reduceri_oferite}}</p>
            </div>
            <div class="form-group row" *ngIf="false">
                <p><b>{{contractTerminationFees}}:
                        <a ngbTooltip="{{contractTerminationFeestooltip}}" tooltipClass="ui-tooltip" placement="right"
                            aria-hidden="true">
                            <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                        </a>
                    </b>
                </p>
            </div>
            <div class="form-group row">
                <p><b>{{reducedApplicationTime}}: </b>
                    <span
                        *ngIf="gasComparatorResult.perioada_reducere_min && gasComparatorResult.perioada_reducere_min !=='01.01.1970'
                         && gasComparatorResult.perioada_reducere_max && gasComparatorResult.perioada_reducere_max !=='01.01.1970'">{{gasComparatorResult.perioada_reducere_min}}
                        - {{gasComparatorResult.perioada_reducere_max}}</span>
                    <span
                        *ngIf="!(gasComparatorResult.perioada_reducere_min && gasComparatorResult.perioada_reducere_max) ||
                        (gasComparatorResult.perioada_reducere_min === '01.01.1970' && gasComparatorResult.perioada_reducere_max === '01.01.1970')">Nu
                        este cazul</span>
                </p>
            </div>
        </div>
        <div class="col-sm shadow m-3 p-3 mb-5 bg-white label-bold rounded">
            <div class="form-group row">
                <p><b>{{priceStructure}}:</b></p>
            </div>
            <div class="form-group row">
                <p><b>{{supplyPrice}} {{onConvertToNumber(supplyPriceValue, 2)}}
                        (lei/MWh), din care:</b></p>
                <p>- {{naturalGasPrice}} : {{gasComparatorResult.pg}} (lei/MWh)</p>
                <p>- {{transportPrice}} : {{gasComparatorResult.tt}} (lei/MWh)</p>
                <p>- {{distributionRate}} : {{gasComparatorResult.t0}} (lei/MWh)</p>
                <p>- {{exciseDuty}} : {{onConvertToNumber(gasComparatorResult.acciza, 2)}} (lei/MWh)</p>
                <p>- {{tva}} ({{gasComparatorResult.tva}}%) : {{onConvertToNumber(tvaValue, 2)}} (lei/MWh)</p>
            </div>
            <div class="form-group row">
                <p><b>{{fixedComponent}}:</b>
                    {{onConvertToNumber(gasComparatorResult.cf)}} lei/zi =
                    {{fixedComponentMonthly}} lei/luna</p>
            </div>
            <div class="form-group row">
                <p><b>{{priceTypeGas}}:</b>
                    {{gasComparatorResult.tip_pret}}</p>
            </div>
            <div class="form-group row">
                <p><b>{{priceApplicationPeriod}}:</b>
                    {{gasComparatorResult.perioada_aplicare_pret}}</p>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isMobileView">
    <div class="row">
        <div class="col-sm shadow m-3 p-3 mb-5 bg-white label-bold rounded">
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label><a href="{{gasComparatorResult.url}}"
                            target="_blank">{{gasComparatorResult.nume}}</a></label>
                    <a style="float:right" href="javascript:void(0);" class="show-button" (click)="showDetails()">
                        <img *ngIf="!isDetailsExpanded" src="../../../../assets/images/arrow-down.png" width="32">
                        <img *ngIf="isDetailsExpanded" src="../../../../assets/images/arrow-up.png" width="32">
                    </a>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{offerName}}:</label>
                </div>
                <div class="col-xl col-md">
                    <a href="{{gasComparatorResult.url_oferta}}" target="_blank">{{gasComparatorResult.nume_oferta}}</a>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{offerType}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{gasComparatorResult.tip_oferta}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{naturalGasPrice}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{gasComparatorResult.pg}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{shippingCost}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{gasComparatorResult.tt}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{distributionCost}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{gasComparatorResult.t0}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{supplyPriceLeiMwh}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{onConvertToNumber(gasComparatorResult.pret_furnizare_mwh, 2)}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{supplyPriceLeiKwh}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span>{{onConvertToNumber(gasComparatorResult.pret_furnizare_kwh, 5)}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{cfValue}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span *ngIf="!gasComparatorResult.cf">0</span>
                    <span *ngIf="gasComparatorResult.cf">{{gasComparatorResult.cf}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{comparisonResult}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span [ngClass]="{'red': onConvertToNumber(gasComparatorResult.rezultat_comparatie) >= 0 ,
                        'green': onConvertToNumber(gasComparatorResult.rezultat_comparatie) < 0 }">
                        <span class="mandatory"
                            *ngIf="!comparatorForm.controls.supplyPriceLeiMwh.value">{{insertActualprice}}</span>
                        <span
                            *ngIf="comparatorForm.controls.supplyPriceLeiMwh.value">{{onConvertToNumber(gasComparatorResult.rezultat_comparatie)}}%
                            <span *ngIf="onConvertToNumber(gasComparatorResult.rezultat_comparatie) > 0"> ⇑
                            </span>
                            <span *ngIf="onConvertToNumber(gasComparatorResult.rezultat_comparatie) < 0"> ⇓
                            </span>
                        </span>
                    </span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{invoiceValue}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span class="mandatory" *ngIf="!+comparatorForm.controls.estimatedMonthlyConsumptionMwh.value">
                        {{enterEstimatedConsumption}}</span>
                    <span *ngIf="+comparatorForm.controls.estimatedMonthlyConsumptionMwh.value">
                        {{(supplyPriceValue * comparatorForm.controls.estimatedMonthlyConsumptionMwh.value
                        ).toFixed(2)}}</span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-xl col-md">
                    <label>{{economyCost}}:</label>
                </div>
                <div class="col-xl col-md">
                    <span [ngClass]="{'red': onConvertToNumber(gasComparatorResult.economie_sau_cost) >= 0 ,
                        'green': onConvertToNumber(gasComparatorResult.economie_sau_cost) < 0 }">
                        <span class="mandatory"
                            *ngIf="!comparatorForm.controls.estimatedMonthlyConsumptionMwh.value || !comparatorForm.controls.supplyPriceLeiMwh.value">
                            {{enterData}}
                        </span>
                        <span
                            *ngIf="comparatorForm.controls.estimatedMonthlyConsumptionMwh.value && comparatorForm.controls.supplyPriceLeiMwh.value">
                            <span *ngIf="onConvertToNumber(gasComparatorResult.economie_sau_cost) > 0">+
                            </span>{{gasComparatorResult.economie_sau_cost}} lei
                        </span>
                    </span>
                </div>
            </div>
            <ng-container *ngIf="isDetailsExpanded">
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{offerValability}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.perioada_oferta_min}}-{{gasComparatorResult.perioada_oferta_max}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{clientType}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.tip_client}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label class="mr-3">{{connectionMethod}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span> {{gasComparatorResult.mod_racordare}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label class="mr-3">{{consumptionCategory}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.categorie_client}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{regulatedServicesIncluded}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.servicii_de_reglementare_incluse}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{lastUpdate}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.ultima_actualizare}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{contractModel}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <ng-container *ngFor="let modelContract of gasComparatorResult.model_contract">
                            <div *ngIf="(!isEditable && modelContract.fisier) || (isEditable && modelContract)"
                                class="form-group row">
                                <div *ngIf="!isEditable && modelContract.fisier" class="col-xl col-md">
                                    <span><a href="{{comparatorDocumentsUrl + modelContract.fisier}}"
                                            target="_blank">{{modelContract.nume}}</a></span>
                                </div>
                                <div *ngIf="isEditable && modelContract" class="col-xl col-md">
                                    <span><a *ngIf="isEditable" href="{{comparatorDocumentsUrl + modelContract}}"
                                            target="_blank">{{modelContract}}</a></span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{contractDuration}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.durata_contract}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{guarantees}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.garantii}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{invoiceFrequency}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.frecventa_emitere_factura}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{paymentTerm}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.termen_plata}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{invoiceTransmissionNethod}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.mod_transmitere_factura}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{documentsMode}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span *ngIf="gasComparatorResult?.mod_transmitere_incheiere_contract"
                            [innerHTML]="gasComparatorResult?.mod_transmitere_incheiere_contract | sanitizeHtml"></span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{discountsOffered}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.reduceri_oferite}}</span>
                    </div>
                </div>
                <div class="form-group row" *ngIf="false">
                    <div class="col-xl col-md">
                        <label>{{contractTerminationFees}}:<a ngbTooltip="{{contractTerminationFeestooltip}}"
                                tooltipClass="ui-tooltip" placement="down" aria-hidden="true">
                                <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                            </a></label>
                    </div>
                    <div class="col-xl col-md">
                        <span></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{reducedApplicationTime}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span
                            *ngIf="gasComparatorResult.perioada_reducere_min && gasComparatorResult.perioada_reducere_min !=='01.01.1970'
                         && gasComparatorResult.perioada_reducere_max && gasComparatorResult.perioada_reducere_max !=='01.01.1970'">{{gasComparatorResult.perioada_reducere_min}}
                            - {{gasComparatorResult.perioada_reducere_max}}</span>
                        <span
                            *ngIf="!(gasComparatorResult.perioada_reducere_min && gasComparatorResult.perioada_reducere_max) ||
                        (gasComparatorResult.perioada_reducere_min === '01.01.1970' && gasComparatorResult.perioada_reducere_max === '01.01.1970')">Nu
                            este cazul</span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{priceStructure}}:</label>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{supplyPrice}} {{gasComparatorResult.pret_furnizare_mwh}} (lei/MWh), din care:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>
                            - {{naturalGasPrice}} <br> {{gasComparatorResult.pg}} (lei/MWh)<br>
                            - {{transportPrice}} <br> {{gasComparatorResult.tt}} (lei/MWh)<br>
                            - {{distributionRate}} <br> {{gasComparatorResult.t0}} (lei/MWh)<br>
                            - {{exciseDuty}} <br> (lei/MWh)<br>
                            - {{tva}} ({{gasComparatorResult.tva}}%) <br> (lei/MWh)<br>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{fixedComponent}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span> {{onConvertToNumber(gasComparatorResult.cf)}} lei/zi =
                            {{fixedComponentMonthly}} lei/luna</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{priceTypeGas}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.tip_pret}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-xl col-md">
                        <label>{{priceApplicationPeriod}}:</label>
                    </div>
                    <div class="col-xl col-md">
                        <span>{{gasComparatorResult.perioada_aplicare_pret}}</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
